import React from 'react';
import cx from 'classnames';

// @ts-ignore
import Copy from '../../images/icons/copy_white.svg';

export const EntityDeletedMessageCopyButton: React.FC<{
  isDarkMode: boolean;
  json?: string;
}> = ({ isDarkMode, json }) => (
  <button
    className={cx(
      'btn btn--small dataset-inspector-viewer__entity-header-copy-button config-code-viewer-copy-button',
      isDarkMode && 'dark'
    )}
    title="Copy unsaved config to clipboard"
    data-clipboard-text={json}
  >
    Copy code <Copy style={{ width: '18px', height: '18px', marginLeft: 4 }} />
  </button>
);
